import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderCheckBoxField from '../../../../Utilities/Forms/RenderCheckBoxField';
interface IProps {
    isReadOnly: boolean
    isResidential: boolean
}

export default function TravelPlanCyclingV2({ isReadOnly, isResidential }: IProps) {
    const { watch, setValue } = useFormContext();
    const formValues = watch();
    const hasValues = (fields: string[]) =>
        fields.some(field => {
            const v = formValues[field];
            return v !== null && v !== undefined && v !== '';
        });

    const onChangeMonth = (name: string, value) => {
        if (typeof value === 'object') {
            setValue(name, null)
        }
    }

    const onChangeYear = (name: string, value) => {
        if (value === 'object') {
            setValue(name, null)
        }
    }
    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {isResidential && (hasValues(["cycleSheds", "cycleShedsMonth", "cycleShedsYear"]) || !isReadOnly) && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycle Parking Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="cycleSheds" label="Are cycle parking facilities (covered/uncovered) provided? (if so, provide details of their nature (covered/uncovered, sheds, cycle racks, cycle compound, etc), plus their locations within the site.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'cycleShedsMonth'} options={monthDropdown} readOnly={isReadOnly} onChange={(v) => onChangeMonth('cycleShedsMonth', v)} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'cycleShedsYear'} readOnly={isReadOnly} onChange={(v) => onChangeYear('cycleShedsYear', v)} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {isResidential && (hasValues(["cycleCompounds", "cycleCompoundsMonth", "cycleCompoundsYear"]) || !isReadOnly) && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycle Compound Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="cycleCompounds" label="Is a covered cycle compound available for any apartment blocks present within the site? (if so, provide details on the nature of the features and locations.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'cycleCompoundsMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'cycleCompoundsYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {!isResidential && (hasValues(["cycleParking", "cycleParkingMonth", "cycleParkingYear"]) || !isReadOnly) && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycle Parking Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="cycleParking" label="Are cycle parking facilities (covered/uncovered) provided? (if so, provide details of their nature (covered/uncovered, sheds, cycle racks, cycle compound, etc), plus their locations within the site.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}><Typography variant="body2">Date Implemented</Typography></Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}><ValidatedSelectElement name="cycleParkingMonth" options={monthDropdown} readOnly={isReadOnly} /></Grid>
                                        <Grid size={6}><ValidatedTextField name="cycleParkingYear" readOnly={isReadOnly} /></Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {(hasValues(["cycleSecurity", "cycleSecurityMonth", "cycleSecurityYear"]) || !isReadOnly) && (
                        <Grid container size={12} >
                            <DataContainer title={"Cycle Security Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="cycleSecurity" label="Are there security features present at the site to encourage cycle parking? (for example illuminated cycle parking areas, secure parking areas, gated access, operational CCTV, etc.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'cycleSecurityMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'cycleSecurityYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>

                    )}

                    {(!isResidential && (hasValues(["cycleRoutes", "cycleRoutesMonth", "cycleRoutesYear", "routesBeforeSite"]) || !isReadOnly)) && (
                        <Grid container size={12} >
                            <DataContainer title={"Cycle Route Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="cycleRoutes" label="Good network of cycle routes linking the site to main residential areas locally" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'cycleRoutesMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'cycleRoutesYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                    <RenderCheckBoxField name="routesBeforeSite" label={"In place prior to the development of the site or otherwise independent of it (i.e. not a Travel Plan element)"} readOnly={isReadOnly} />
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {(isResidential && (hasValues(["routesToDestinations", "resRoutesMonth", "resRoutesYear", "resRoutesBeforeSite"]) || !isReadOnly)) && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycle Route Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="routesToDestinations" label="Are there local cycle routes available that link the site to areas of employment, education, local amenities and/or public transport connections?" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}><Typography variant="body2">Date Implemented</Typography></Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}><ValidatedSelectElement name="resRoutesMonth" options={monthDropdown} readOnly={isReadOnly} /></Grid>
                                        <Grid size={6}><ValidatedTextField name="resRoutesYear" readOnly={isReadOnly} /></Grid>
                                    </Stack>
                                    <RenderCheckBoxField name="resRoutesBeforeSite" label="In place prior to the development of the site or otherwise independent of it (i.e. not a Travel Plan element)" readOnly={isReadOnly} />
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {!isResidential && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycling Facilities and Incentives"}>
                                <Stack spacing={1}>
                                    <Typography variant="body2">Which of the following facilities or incentives are available for cyclists, runners or walkers at the site?</Typography>
                                    <RenderSelectField name="showers" label="Showers" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderSelectField name="lockers" label="Lockers for clothing and helmet storage" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderSelectField name="laundryService" label="Towels, laundry or drying service provided by the site" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderSelectField name="bikeStorage" label="Storage of folding or standard bikes within workspaces" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderSelectField name="freeBreakfast" label="Free breakfast" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderSelectField name="otherCycleFacility" label="Other" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <RenderTextField name="otherCycleFacilityText" label="Other details" readOnly={isReadOnly} />
                                    <RenderSelectField name="cyclingEvents" label="Are events to encourage cycling offered to staff?" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}><Typography variant="body2">Date Implemented</Typography></Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}><ValidatedSelectElement name="cyclingEventsMonth" options={monthDropdown} readOnly={isReadOnly} /></Grid>
                                        <Grid size={6}><ValidatedTextField name="cyclingEventsYear" readOnly={isReadOnly} /></Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    <Grid container size={12} >
                        <DataContainer title={"Additional Comments"}>
                            <RenderTextField label={'Specify details of all Travel Plan elements identified in this section, along with any other cycling features not already covered.'} name={'cycleComments'} readOnly={isReadOnly} multiLine={true} rows={4} labelSize={12} inputSize={12} alwaysShow={true} />
                        </DataContainer>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
